// import layoutHeaderAside from '@/layout/header-aside'
import layoutHeaderAside from '@/layout/header-only'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

export default {
  path: '/my/',
  name: 'my',
  meta: {
    auth: true
  },
  redirect: {
    name: 'my-index'
  },
  component: layoutHeaderAside,
  children: (pre => [
    {
      path: 'password',
      name: `${pre}password`,
      component: _import('my/password'),
      meta: {
        title: '修改密码'
      }
    },
    {
      path: 'profile',
      name: `${pre}profile`,
      component: _import('my/profile'),
      meta: {
        title: '修改资料'
      }
    }
  ])('my-')
}
